import React from 'react';
import Container from 'react-bootstrap/Container';
import { Col, Row, Button } from 'react-bootstrap';

const Home = (props) => (
  <Container>
    <Row>
      <Col>
        <h1 className="brand-text">moneyplant</h1>
      </Col>
    </Row>

    <Row>
      <Col>
        <h5 className="text-muted">Your Wealth, Your Way. Completely Private.</h5>
        <p className="lead">Track your financial health without handing over your bank credentials. Full control, 100% privacy.</p>
      </Col>
    </Row>

    <Row>
      <Col>
        {
          props.user ? (
            <React.Fragment>
              <h4 className="text-muted">Welcome Back, { props.user.attributes.given_name }!</h4>
              <p className="text-muted">Track your financial progress with ease and security. Ready to dive deeper into your wealth?</p>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <h6 className="text-muted">Enjoy full control over your wealth tracking without the hassles of a spreadsheet.</h6>
              <ul className="text-muted">
                <li>⏱ <strong>Save time.</strong> Automatic reports and insights with no complex formulas.</li>
                <li>🔐 <strong>Full privacy.</strong> Manual entry means your data stays secure, no account linking required.</li>
                <li>📊 <strong>Instant insights.</strong> See your net worth, growth, and trends at a glance.</li>
                <li>🛠 <strong>Customizable.</strong> Track exactly what matters to you with flexible categories.</li>
                <li>🌍 <strong>Global support.</strong> Track 100+ fiat currencies and 800+ cryptocurrencies.</li>
              </ul>

              <div className="text-center">
                <h5>Why Choose Us?</h5>
                <p>Moneyplant offers <strong>manual entry with a streamlined experience</strong>, giving you control over your data and automated reports without the complexity of spreadsheets.</p>
                <Button variant="primary" size="lg" onClick={props.onGetStarted}>
                  Get Started Now
                </Button>
              </div>
            </React.Fragment>
          )
        }
      </Col>
    </Row>
  </Container>
)

export default Home;